import React, { useState } from "react";
import { DatePicker, Modal, Table } from "antd";
import dayjs from "dayjs";
import { GetIdCurrencyEditApi } from "../../api/listCurrencyDescription";
import { getLogsDescriptionMonth } from "../../api/APIProjectDescription";
import { EditOutlined, FileTextOutlined } from "@ant-design/icons";
import ModalEditMonthDescription from "./ModalEditMonthDescription";
import ModalLogMonthDescription from "./ModalLogMonthDescription";

const ModalMoneyDateDescription = ({
  isModalOpenMoneyDate,
  handleOkMoneyDate,
  setIsModalOpenMoneyDate,
  currentYear,
  setCurrentYear,
  dataMoneyDate,
  idEditCurrency,
  setDataMoneyDate,
}) => {

  // State để quản lý modal con Edit Month
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editMonthData, setEditMonthData] = useState(null);
  // State để quản lý modal con Logs Month
  const [logsModalOpen, setLogsModalOpen] = useState(false);
  const [logsMonthData, setLogsMonthData] = useState([]);

  // Dữ liệu tháng
  const [valueMonth, setValueMonth] = useState(null);

  // Hàm fetch lại data từ server
  const fetchData = () => {
    GetIdCurrencyEditApi({ id: idEditCurrency, year: currentYear })
      .then((response) => {
        setDataMoneyDate(response.data.message);
        console.log("Dữ liệu đã được cập nhật!");
      })
      .catch((error) => {
        console.log("Fetch data failed:", error);
      });
  };


  // Xử lý thay đổi năm
  const handleYear = (date, dateString) => {
    const selectedYear = dayjs(dateString).year();
    setCurrentYear(selectedYear);
    GetIdCurrencyEditApi({ id: idEditCurrency, year: selectedYear })
      .then((re) => {
        setDataMoneyDate(re.data.message);
        setIsModalOpenMoneyDate(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Hiển thị modal con để chỉnh sửa dữ liệu
  const handleEdit = (month) => {
    const monthData = dataMoneyDate.find((item) => item.month === month);
    setValueMonth(month);
    setEditMonthData(monthData);
    setEditModalOpen(true);
  };

  const handleLogs = (month) => {
    const monthData = dataMoneyDate.find((item) => item.month === month);
    setValueMonth(month);
    // Nếu chưa có data thì không mở modal
    const id_logs_month = monthData?.id.toString();
    if (id_logs_month) {
      getLogsDescriptionMonth({ id: id_logs_month })
        .then((re) => {
          setLogsMonthData(re.data.log);
          setLogsModalOpen(true);

        })
        .catch((err) => {
          console.log(err);
        });

    }

  };

  // Tạo dữ liệu cho bảng
  const tableData = [
    {
      key: "unit_price_total",
      type: "Unit Price Total",
      ...Object.fromEntries(dataMoneyDate.map((item) => [item.month, item.unit_price_total])),
    },
    {
      key: "rsvn_to_rsjp",
      type: "RSVN to RSJP",
      ...Object.fromEntries(dataMoneyDate.map((item) => [item.month, item.rsvn_to_rsjp])),
    },
    {
      key: "rsvn_to_rsjp_unit_price",
      type: "RSVN to RSJP Unit Price",
      ...Object.fromEntries(dataMoneyDate.map((item) => [item.month, item.rsvn_to_rsjp_unit_price])),
    },
    {
      key: "actions",
      type: "Actions",
      ...Object.fromEntries(
        Array.from({ length: 12 }, (_, i) => [(i + 1).toString(),
        {
          edit: true,
          logs: true,
        },
        ])
      ),
    },
  ];

  const tableColumns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      align: "left",
    },
    ...Array.from({ length: 12 }, (_, i) => {
      // Tháng từ 1 đến 12
      const month = (i + 1).toString();
      // Lấy ngày hiện tại
      const currentDay = dayjs().date();
      // Lấy tháng hiện tại (1-based)
      const currentMonth = dayjs().month() + 1; 
      return {
        title: `Tháng ${month}`,
        dataIndex: month,
        key: month,
        align: "center",
        render: (text, record) => {
          if (record.key === "actions") {
            // Chỉ hiển thị Button Edit từ tháng hiện tại trở đi và ngày hiện tại <= 20
            if ((month >= currentMonth) || ( month === currentMonth-1  &&  currentDay <= 20)) {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <EditOutlined
                    title="Chỉnh sửa"
                    style={{ cursor: "pointer", color: "#1890ff" }}
                    onClick={() => handleEdit(month)} // Truyền month
                  />
                  <FileTextOutlined
                    title="Logs"
                    style={{ cursor: "pointer", color: "#52c41a" }}
                    onClick={() => handleLogs(month)} // Truyền month
                  />
                </div>
              );
            }
            // Ngược lại hiển thị Button Log cho tháng
            else {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >

                  <FileTextOutlined
                    title="Logs"
                    style={{ cursor: "pointer", color: "#52c41a" }}
                    onClick={() => handleLogs(month)} // Truyền month
                  />
                </div>
              );
            }
          }
          // Hiển thị giá trị bình thường cho các hàng khác
          return <span>{text || "-"}</span>;
        },
      };
    }),
  ];

  const dateFormat = "YYYY";

  return (
    <>
      <Modal
        title="DATE MONEY"
        open={isModalOpenMoneyDate}
        onOk={handleOkMoneyDate}
        onCancel={() => setIsModalOpenMoneyDate(false)}
        footer={false}
        width={1350}
        forceRender={true}
        className="headerTitleModal"
      >
        <DatePicker
          allowClear={false}
          picker="year"
          defaultValue={dayjs(`${currentYear}`, dateFormat)}
          format={dateFormat}
          onChange={handleYear}
          value={dayjs(`${currentYear}`, dateFormat)}
          style={{ marginBottom: "10px" }}
        />
        <Table columns={tableColumns} dataSource={tableData} pagination={false} />
      </Modal>

      {/* Modal Edit Month Description */}
      <ModalEditMonthDescription
        isOpen={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        month={valueMonth} // Giá trị tháng
        editMonthData={editMonthData} // Dữ liệu của tháng cần sửa
        fetchData={fetchData} // Truyền fetchData để cập nhật modal cha
      />

      {/* Modal Logs Month Description */}
      <ModalLogMonthDescription
        isOpen={logsModalOpen}
        onClose={() => setLogsModalOpen(false)}
        month={valueMonth}
        logsMonthData={logsMonthData}
      />

    </>
  );
};

export default ModalMoneyDateDescription;
